import { Commit } from 'vuex';
import { version } from '../../package.json';

interface CommitFunction {
  commit: Commit;
}

interface config{
  version: string;
  testnetUrl: string;
  testnetLabel: string;
  testnetApi: string;
  testnetNetworkType: number;
  testnetExplorer: string;
  testnetWebWallet: string;
  testnetGenerationHash: string;
  testnetXPXAssetId: string;
  mainnetUrl: string;
  mainnetLabel: string;
  mainnetApi: string;
  mainnetNetworkType: number;
  mainnetExplorer: string;
  mainnetWebWallet: string;
  mainnetGenerationHash: string;
  mainnetXPXAssetId: string;
  assetUrl: string;
  GAnalyticsID: string;
  Testnet2MobileApkVersion: string;
  enableMainnet: boolean;
}


interface State{
  firstApiLoad: boolean;
  version: string;
  testnetUrl: string;
  testnetLabel: string;
  testnetApi: string;
  testnetNetworkType: number;
  testnetExplorer: string;
  testnetWebWallet: string;
  testnetGenerationHash: string;
  testnetXPXAssetId: string;
  mainnetUrl: string;
  mainnetLabel: string;
  mainnetApi: string;
  mainnetNetworkType: number;
  mainnetExplorer: string;
  mainnetWebWallet: string;
  mainnetGenerationHash: string;
  mainnetXPXAssetId: string;
  packageVersion: string;
  assetUrl: string;
  GAnalyticsID: string;
  isDropDown: boolean;
  Testnet2MobileApkVersion: string;
  enableMainnet: boolean;
}

export const config = {
  namespaced: true,
  state: {
    firstApiLoad: sessionStorage.getItem("firstLoad")? JSON.parse(sessionStorage.getItem("firstLoad")) : false,
    version: localStorage.getItem("version")? JSON.parse(localStorage.getItem("version")) : '',
    testnetUrl: localStorage.getItem("testnetUrl")? JSON.parse(localStorage.getItem("testnetUrl")) : '',
    testnetLabel: localStorage.getItem("testnetLabel")? JSON.parse(localStorage.getItem("testnetLabel")) : '',
    testnetApi: localStorage.getItem("testnetApi")? JSON.parse(localStorage.getItem("testnetApi")) : '',
    testnetNetworkType: localStorage.getItem("testnetNetworkType")? JSON.parse(localStorage.getItem("testnetNetworkType")) : '',
    testnetExplorer: localStorage.getItem("testnetExplorer")? JSON.parse(localStorage.getItem("testnetExplorer")) : '',
    testnetGenerationHash: localStorage.getItem("testnetGenerationHash")? JSON.parse(localStorage.getItem("testnetGenerationHash")) : '',
    testnetXPXAssetId: localStorage.getItem("testnetXPXAssetId")? JSON.parse(localStorage.getItem("testnetXPXAssetId")) : '',
    mainnetUrl: localStorage.getItem("mainnetUrl")? JSON.parse(localStorage.getItem("mainnetUrl")) : '',
    mainnetLabel: localStorage.getItem("mainnetLabel")? JSON.parse(localStorage.getItem("mainnetLabel")) : '',
    mainnetApi: localStorage.getItem("mainnetApi")? JSON.parse(localStorage.getItem("mainnetApi")) : '',
    mainnetNetworkType: localStorage.getItem("mainnetNetworkType")? JSON.parse(localStorage.getItem("mainnetNetworkType")) : '',
    mainnetExplorer: localStorage.getItem("mainnetExplorer")? JSON.parse(localStorage.getItem("mainnetExplorer")) : '',
    mainnetGenerationHash: localStorage.getItem("mainnetGenerationHash")? JSON.parse(localStorage.getItem("mainnetGenerationHash")) : '',
    mainnetXPXAssetId: localStorage.getItem("mainnetXPXAssetId")? JSON.parse(localStorage.getItem("mainnetXPXAssetId")) : '',
    assetUrl: localStorage.getItem("assetUrl")? JSON.parse(localStorage.getItem("assetUrl")) : '',
    GAnalyticsID: localStorage.getItem("GAnalyticsID")? JSON.parse(localStorage.getItem("GAnalyticsID")) : '',
    Testnet2MobileApkVersion: localStorage.getItem("Testnet2MobileApkVersion")? JSON.parse(localStorage.getItem("Testnet2MobileApkVersion")) : '',
    packageVersion: version || '0',
    isDropDown: false,
  },

  getters: {
    getTestnetUrl(state:State):string{
      return state.testnetUrl;
    },

    getTestnetApi(state:State):string{
      return state.testnetApi;
    },

    getTestnetNetworkType(state:State):number{
      return state.testnetNetworkType;
    },

    getTestnetExplorer(state:State):string{
      return state.testnetExplorer;
    },

    getTestnetWebWallet(state:State):string{
      return state.testnetWebWallet;
    },

    getTestnetGenerationHash(state:State):string{
      return state.testnetGenerationHash;
    },

    getTestnetXPXAssetId(state:State):string{
      return state.testnetXPXAssetId;
    },

    configTestnetLabel(state:State):string{
      return state.testnetLabel;
    },

    getMainnetUrl(state:State):string{
      return state.mainnetUrl;
    },

    getMainnetApi(state:State):string{
      return state.mainnetApi;
    },

    getMainnetNetworkType(state:State):number{
      return state.mainnetNetworkType;
    },

    getMainnetExplorer(state:State):string{
      return state.mainnetExplorer;
    },

    getMainnetWebWallet(state:State):string{
      return state.mainnetWebWallet;
    },

    getMainnetGenerationHash(state:State):string{
      return state.mainnetGenerationHash;
    },

    getMainnetXPXAssetId(state:State):string{
      return state.mainnetXPXAssetId;
    },

    configMainnetLabel(state:State):string{
      return state.mainnetLabel;
    },

    assetUrl(state:State):string{
      return state.assetUrl;
    },

    appVersion(state:State):string {
      return state.packageVersion;
    },

    isFirstLoad(state: State):boolean{
      return state.firstApiLoad;
    },

    GAnalyticsID(state: State):string{
      return state.GAnalyticsID;
    },

    isDropDown(state: State):boolean{
      return state.isDropDown;
    },

    getTestnet2MobileApkVersion(state: State):string{
      return state.Testnet2MobileApkVersion;
    },

    getEnableMainnet(state: State):boolean{
      return state.enableMainnet;
    }
  },

  mutations: {
    SET_CONFIG (state:State, payload:config ):void{
      state.version = payload.version;
      state.testnetLabel = payload.testnetLabel;
      state.testnetUrl = payload.testnetUrl;
      state.testnetApi = payload.testnetApi;
      state.testnetNetworkType = payload.testnetNetworkType;
      state.testnetExplorer = payload.testnetExplorer;
      state.testnetWebWallet = payload.testnetWebWallet;
      state.testnetGenerationHash = payload.testnetGenerationHash;
      state.mainnetLabel = payload.mainnetLabel;
      state.mainnetUrl = payload.mainnetUrl;
      state.mainnetApi = payload.mainnetApi;
      state.mainnetNetworkType = payload.mainnetNetworkType;
      state.mainnetExplorer = payload.mainnetExplorer;
      state.mainnetWebWallet = payload.mainnetWebWallet;
      state.mainnetGenerationHash = payload.mainnetGenerationHash;
      state.assetUrl = payload.assetUrl;
      state.GAnalyticsID = payload.GAnalyticsID;
      state.Testnet2MobileApkVersion = payload.Testnet2MobileApkVersion;
      state.enableMainnet = payload.enableMainnet;
    },

    SET_FIRST_API_LOAD(state:State):void{
      sessionStorage.setItem("firstLoad", JSON.stringify(true));
      state.firstApiLoad = true;
    },

    SET_MENU_DROP_DOWN(state: State, payload:boolean):void{
      state.isDropDown = payload;
    }
  },

  actions: {
    getconfig: ({commit}: CommitFunction, payload: config):void => {
      commit('SET_CONFIG', payload);
    },

    setFirstLoad: ({commit}: CommitFunction):void => {
      commit('SET_FIRST_API_LOAD');
    },

    setDropDown: ({commit}: CommitFunction, payload: boolean):void => {
      commit('SET_MENU_DROP_DOWN', payload);
    },
  }
}

